<div class="flex flex-auto">
    <p-autoComplete minLength="3" appendTo="body" [suggestions]="diagnosisSuggestions"  [(ngModel)]="diagnoses" multiple 
                        (completeMethod)="diagnosisSearch($event)" (onSelect)="selectDiagnosis($event)" (onUnselect)="selectDiagnosis($event)" placeholder="Search Diagnoses" optionLabel="code"
                        dataKey="code" class="m-2 flex flex-auto" styleClass="flex flex-auto" inputStyleClass="flex flex-auto">
        <ng-template let-diagnosis pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" >{{ diagnosis.code }} - {{diagnosis.description | slice : 0 : 100}}<span *ngIf="diagnosis.description.length > 100">...</span></div>
            </div>
        </ng-template>
    </p-autoComplete>
</div>